import { Grid } from '@mui/material';
import { useState, useMemo, useEffect, type FC } from 'react';
import { Outlet } from 'react-router';

import Provision from '../../api/provision';
import useApiQuery from '../../hooks/useApiQuery';

import { ReportsContext, type ReportsContextType } from './ReportsContext';

import type { Cloud, VirtualCloud } from '@/types/cloudTypes';
import type { Hypervisor, HypervisorDetail } from '@/types/hypervisorTypes';
import type { OsProject } from '@/types/productTypes';

const Reports: FC = () => {
  const [hypervisorCloudId, setHypervisorCloudId] = useState<string | undefined>();
  const [hypervisors, setHypervisors] = useState<Hypervisor[]>([]);
  const [juiceGroupCloudId, setJuiceGroupCloudId] = useState<string | undefined>();
  const [osProjects, setOsProjects] = useState<OsProject[]>([]);
  const [hypervisorDetails, setHypervisorDetails] = useState<HypervisorDetail[]>([]);
  const [clouds, setClouds] = useState<Cloud[]>([]);
  const [tenantsVirtualClouds, setTenantsVirtualClouds] = useState<VirtualCloud[]>([]);
  const { makeApiCall: fetchClouds } = useApiQuery(Provision.fetchClouds);

  useEffect(() => {
    const getClouds = async () => {
      const data = (await fetchClouds()) as Cloud[] | null;

      if (data && Array.isArray(data)) {
        setClouds(data);
      }
    };
    getClouds();
  }, [fetchClouds]);

  const contextValue = useMemo(
    () => ({
      juiceGroup: {
        cloudId: juiceGroupCloudId ?? '',
        setCloudId: setJuiceGroupCloudId,
        osProjects,
        setOsProjects,
        clouds,
      },
      hypervisor: {
        cloudId: hypervisorCloudId,
        setCloudId: setHypervisorCloudId,
        hypervisors,
        setHypervisors,
        hypervisorDetails,
        setHypervisorDetails,
        clouds,
      },
      allVirtualClouds: {
        tenantsVirtualClouds,
        setTenantsVirtualClouds,
      },
    }),
    [
      juiceGroupCloudId,
      osProjects,
      clouds,
      hypervisorCloudId,
      hypervisors,
      hypervisorDetails,
      tenantsVirtualClouds,
    ]
  );

  return (
    <Grid
      container
      justifyContent='space-between'
    >
      <Grid
        item
        xs={14}
      >
        <ReportsContext.Provider value={contextValue as unknown as ReportsContextType}>
          <Outlet />
        </ReportsContext.Provider>
      </Grid>
    </Grid>
  );
};

export default Reports;
